import serviceAxios from "../request.js";

// 获取登录二维码

export const getLoginCode = (params) => {
  return serviceAxios({
    url: "/getLoginCode",
    method: "get",
    params,
  });
};

// 检查是否授权
export const checkLoginCode = (params) => {
  return serviceAxios({
    url: "/checkLoginCode",
    method: "get",
    params,
  });
};

// 获取用户昵称
export const getMyInfo = (data) => {
  return serviceAxios({
    url: "/mine/getMyInfo",
    method: "post",
    data,
  });
};

// 获取认证状态
export const getAuthInformation = (params) => {
  return serviceAxios({
    url: "/login/getAuthInformation",
    method: "get",
    params,
  });
};

// 获取实名认证信息（认证结果/说明弹窗内容判定）
export const getRealNameAuthInfo = (params) => {
  return serviceAxios({
    url: "/api/realname/auth/info",
    method: "get",
    params,
  });
};

// 客服按钮点击埋点（无参数，失败静默）
export const logCustomerServiceClick = (data) => {
  return serviceAxios({
    url: "/api/customerServiceLog/logClick",
    method: "post",
    data,
  });
};

// 退出登录
export const LogOut = (params) => {
  return serviceAxios({
    url: "/loginOut",
    method: "get",
    params,
  });
};
